import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { ApiError, httpClient } from '@/api/http-client'

export async function losePreProgrammedDeal(dealKey: string) {
  const response = await httpClient('accounting-dealer').put<void>(
    `/v3/deal/${dealKey}/pre-programmed/lose`,
    { lost_reason: 'client_declined', penalty_applied: true },
    { ignoreErrorToast: true },
  )

  return response.data
}

export function useLosePreProgrammedDeal(
  options?: UseMutationOptions<unknown, ApiError, string, unknown>,
) {
  return useMutation({
    mutationFn: losePreProgrammedDeal,
    ...options,
  })
}
